import React, { useState, useEffect, useRef } from "react";
import PreviewImage from "../../../images/img.png";
import { Button, Flex, Image, Input, Text, Textarea } from "@chakra-ui/react";
import {
    addContentText,
    addContentImage,
    editContentText,
    editContentImage,
} from "../../../services/SolutionDetailAPI";
import { useRecoilValue, useRecoilState } from "recoil";
import {
    SOLUTION_SUBJECT_ID,
    SOLUTION_CONTENT_ID,
    IS_MODIFY_MODE,
    CONTENT_TYPE,
    CURRENT_CONTENT,
} from "../../../recoilState/Atoms";

const ContentAddModal = (props) => {
    const contentId = useRecoilValue(SOLUTION_CONTENT_ID);
    const subjectId = useRecoilValue(SOLUTION_SUBJECT_ID);
    const currentContent = useRecoilValue(CURRENT_CONTENT);
    const [isModifyMode, setIsModifyMode] = useRecoilState(IS_MODIFY_MODE);
    const [type, setType] = useRecoilState(CONTENT_TYPE);
    const [content, setContent] = useState("");
    const [file, setFile] = useState(null); // 파일 임시 저장 변수
    const [imgBase64, setImgBase64] = useState(null); // 파일 base64
    const [imgName, setImgName] = useState(null);
    const inputRef = useRef(null);

    const handleChangeContent = (event) => setContent(event.target.value);

    const handleClick = () => {
        inputRef.current.click();
    };

    const fileChange = (event) => {
        setFile(event.target.files[0]);

        setImgBase64([]);

        for (var i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i]) {
                let reader = new FileReader();
                reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장.
                // 파일 상태 업데이트
                reader.onloadend = () => {
                    // 2. 읽기가 완료되면 아래코드가 실행.
                    const base64 = reader.result;
                    if (base64) {
                        // 문자 형태로 저장
                        var base64Sub = base64.toString();
                        // 배열 state 업데이트
                        setImgBase64((imgBase64) => [...imgBase64, base64Sub]);
                    }
                };
            }
        }
    };

    const confirmForm = () => {
        if (type === "text") {
            if (content === "" || content === null) {
                alert("텍스트를 입력해주세요!");
            } else {
                if (isModifyMode) {
                    editContentText(contentId, content).then(() => {
                        props.setUpdateState(Math.random());
                        alert("텍스트 수정이 완료되었습니다!");
                        props.setIsModalOpen(false);
                    });
                } else {
                    addContentText(subjectId, content).then(() => {
                        props.setUpdateState(Math.random());
                        alert("텍스트 추가가 완료되었습니다!");
                        props.setIsModalOpen(false);
                    });
                }
            }
        } else {
            if (imgBase64 === null) {
                alert("이미지를 업로드 해주세요!");
            } else {
                if (isModifyMode) {
                    if (file === null) {
                        alert("변동된 내역이 없습니다.");
                    } else {
                        editContentImage(contentId, file).then(() => {
                            props.setUpdateState(Math.random());
                            alert("이미지 수정이 완료되었습니다!");
                            props.setIsModalOpen(false);
                        });
                    }
                } else {
                    addContentImage(subjectId, file).then(() => {
                        props.setUpdateState(Math.random());
                        alert("이미지 추가가 완료되었습니다!");
                        props.setIsModalOpen(false);
                    });
                }
            }
        }
    };

    useEffect(() => {
        file && setImgName(file.name);
    }, [file]);

    useEffect(() => {
        if (isModifyMode) {
            let splitedName = currentContent.split("/");
            setContent(currentContent);
            setImgName(splitedName[splitedName.length - 1]);
            setImgBase64(currentContent);
        }
    }, [isModifyMode]);

    return (
        <Flex alignItems="center" direction="column">
            <Flex alignContent="center" mb="10px" mt="10px">
                <Button
                    ml="5px"
                    width="80px"
                    fontSize="xl"
                    height="25px"
                    size="md"
                    colorScheme={type == "text" ? "red" : "gray"}
                    isDisabled={isModifyMode ? (type == "text" ? false : true) : false}
                    onClick={() => setType("text")}
                >
                    텍스트
                </Button>
                <Button
                    ml="5px"
                    width="80px"
                    fontSize="xl"
                    height="25px"
                    size="md"
                    colorScheme={type == "image" ? "red" : "gray"}
                    isDisabled={isModifyMode ? (type == "image" ? false : true) : false}
                    onClick={() => setType("image")}
                >
                    이미지
                </Button>
            </Flex>

            <Text fontSize="5xl" as="b" mb="30px" mt="10px">
                {isModifyMode ? "컨텐츠 수정" : "컨텐츠 추가"}
            </Text>
            {type === "text" ? (
                <Textarea
                    htmlSize={15}
                    textAlign="top"
                    fontSize="20px"
                    h="275px"
                    w="300px"
                    value={content}
                    placeholder="텍스트를 입력해주세요"
                    _placeholder={{ opacity: 0.4, color: "inherit" }}
                    onChange={handleChangeContent}
                    size="sm"
                />
            ) : (
                <>
                    <Flex alignContent="center" mb="10px" mt="10px">
                        <Image
                            mt="10px"
                            mb="10px"
                            height="200px"
                            src={imgBase64 ? imgBase64 : PreviewImage}
                            alt="미리보기"
                        />
                    </Flex>
                    <Flex mb="8px" mt="2px">
                        <Input width="150px" value={imgName} readOnly />
                        <Button
                            ml="5px"
                            width="80px"
                            fontSize="xl"
                            height="25px"
                            size="md"
                            colorScheme="red"
                            onClick={handleClick}
                        >
                            이미지 선택
                        </Button>
                        <input
                            style={{ display: "none" }}
                            ref={inputRef}
                            type="file"
                            accept="image/*"
                            onChange={fileChange}
                        />
                    </Flex>
                </>
            )}

            <Flex mt="30px" mb="10px">
                <Button
                    fontSize="xl"
                    size="md"
                    colorScheme="red"
                    mr={3}
                    onClick={() => {
                        setIsModifyMode(false);
                        props.setIsModalOpen(false);
                    }}
                >
                    닫기
                </Button>
                <Button
                    fontSize="xl"
                    size="md"
                    colorScheme="gray"
                    onClick={() => {
                        confirmForm();
                    }}
                >
                    {isModifyMode ? "수정" : "추가"}
                </Button>
            </Flex>
        </Flex>
    );
};

export default ContentAddModal;
